module.exports = __webpack_public_path__ + "static/img/stab_483.cd9560e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/stab_483.jpg
// module id = wRgy
// module chunks = 0